import { CoreDomainSearchStore, DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React, { createContext, useContext, useEffect } from 'react';
import { useDomainSearchGateBi } from '../../hooks/useDomainSearchGateBi';
import { useQuerySubmit } from '../../hooks/useQuerySubmit';
import { useRecommendations } from '../../hooks/useRecommendations';
import { useResultsPageOfferingsBi } from '../../hooks/useResultsPageOfferingsBi';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
const ResultsPageContext = /*#__PURE__*/createContext(null);
export const useResultsPageContext = () => {
  const value = useContext(ResultsPageContext);
  if (!value) {
    throw new Error('useResultsPageContext must be used within a ResultsPageProvider');
  }
  return value;
};

// Non-throwing variant for components that may render outside a
// ResultsPageProvider (e.g. the header rendered standalone in stories).
export const useResultsPageContextSafe = () => useContext(ResultsPageContext);
export const ResultsPageProvider = _ref => {
  let {
    biViewMode,
    reportGatePageLoadEvents = true,
    useReferralAdditionalInfoAsSearchOrigin = false,
    querySubmitPath = '/',
    isResultsPageOptimizations = false,
    deviceType,
    productType,
    children
  } = _ref;
  DomainSearchGateModule.SDK.hooks.useDomainsSearchGateBM();
  useDomainSearchGateBi({
    viewMode: biViewMode,
    reportGatePageLoadEvents,
    useReferralAdditionalInfoAsSearchOrigin
  });
  const {
    recommendations,
    isLoading,
    query,
    hasNextPage: hasMore,
    fetchNextPage,
    isFetchingNextPage,
    error,
    biError,
    onRetry,
    isPricingLoading
  } = useRecommendations({
    enableOnEmptyQuery: false,
    productType
  });
  const {
    resolveActionForSuggestion
  } = DomainSearchSuiteModule.SDK.useSuggestionActionResolver();
  const {
    updateUrl
  } = DomainSearchSuiteModule.SDK.hooks.useUrlRecovery();
  useQuerySubmit({
    path: querySubmitPath
  });
  useResultsPageOfferingsBi({
    recommendations,
    isLoading,
    biError
  });
  useEffect(() => {
    return () => {
      CoreDomainSearchStore.resetStore();
    };
  }, []);
  const emptyQueryStatus = !isLoading && recommendations.length > 0 && !query;
  return /*#__PURE__*/React.createElement(ResultsPageContext.Provider, {
    value: {
      recommendations,
      isLoading,
      query,
      hasMore,
      fetchNextPage,
      isFetchingNextPage,
      error,
      onRetry,
      isPricingLoading,
      emptyQueryStatus,
      updateUrl,
      resolveActionForSuggestion,
      isResultsPageOptimizations,
      deviceType,
      productType
    }
  }, children);
};
//# sourceMappingURL=ResultsPageContext.js.map